import axios from 'axios';
import { getActiveStoreId } from '../lib/storefront/storeBootstrap.js';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchGalleryPhotos = async () => {
    const storeId = getActiveStoreId();
    const response = await axios.get(`${API_URL}/api/photo-gallery`, {
        headers: storeId ? { 'X-Store-Id': storeId } : undefined,
    });
    return response.data;
};
